var _defs, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueSwapArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M10.293 12.293a.999.999 0 0 1 1.414 0l4 3.999a.99.99 0 0 1 .216.326.991.991 0 0 1-.217 1.09l-3.999 3.999a.999.999 0 1 1-1.414-1.414L12.586 18H2a1 1 0 1 1 0-2h10.586l-2.293-2.293a.999.999 0 0 1 0-1.414zm-4.586-12a.999.999 0 0 1 0 1.414L3.414 4H14a1 1 0 1 1 0 2H3.414l2.293 2.293a.999.999 0 1 1-1.414 1.414L.294 5.708a.99.99 0 0 1-.217-.326.991.991 0 0 1 .217-1.09l4-3.999a.999.999 0 0 1 1.413 0z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#14BAD8",
    fillRule: "evenodd",
    transform: "translate(4 1)",
    xlinkHref: "#a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSwapArrows);
export default __webpack_public_path__ + "static/media/blue-swap-arrows.abcc04e7fc7a436ad538e3514d42ef9c.svg";
export { ForwardRef as ReactComponent };